import {all} from 'redux-saga/effects';
import {AdminStoreSages} from "../admin/store/admin-store-sagas";

export default function* rootSaga() {
    yield all([
        AdminStoreSages(),
    ]);
}